'use strict';

/**
 *
 * Form validation - success/error/redirect/or just message
 * jQuery dependency needed
 * HTML: onsubmit="return XXX._form(this);" and loading layer inside form <div class="loading"></div>
 */

var UTILS = UTILS || {};

const loadScript = (src, callback) => {
    let s; let r; let t;

    r = false;
    s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = src;
    s.onload = s.onreadystatechange = function () {
        if (!r && (!this.readyState || this.readyState === 'complete')) {
            r = true;

            if (callback) {
                callback();
            }
        }
    };
    t = document.getElementsByTagName('script')[0];
    t.parentNode.insertBefore(s, t);
};

function trackFormSubmission({status, eventName, eventCategoryName}) {
    if (window['dataLayer'] === undefined) {
        return;
    }

    window.dataLayer.push({
        'event': eventName,
        'event-category': eventCategoryName,
        'form-submission-status': status
    });
}

UTILS.form = function form(form, url, eventName = 'contact-form-submission', eventCategoryName = 'Contact Form') {
    let data = $(form).serialize(),
        loading = true,
        buttonTextOriginal = '',
        targetId = undefined;

    $(form).find('.loading').fadeIn();
    buttonTextOriginal = $(form).find('button[type="submit"]').text();
    $(form).find('button[type="submit"]').text('Sending...');

    if (form.getAttribute('data-target-id')) {
        targetId = form.getAttribute('data-target-id');
    };

    $.ajax({
        url: url,
        method: 'POST',
        data: data,
        dataType: 'json'
    })
    .then(function(response) {
        trackFormSubmission({status: 'Successful', eventName, eventCategoryName});

        $(form).find('button[type="submit"]').text(buttonTextOriginal);
        $(form).find('.loading').fadeOut();

        if (response.url) {
            if (Barba) {
                Barba.Pjax.goTo( response.url );
            } else {
                window.location.href = response.url;
            }
        } else {
            $(form).find('.loading').fadeOut();

            if ( $(form).find('.form__response--ok').length === 0 ) {
                $(form).prepend( '<div class="form__response form__response--ok"><p>'+response.message+'</p></div>' );
            } else {
                $('.form__response--ok p').html(response.message);
            }

            if (targetId) {
                if (response.html) {
                    document.querySelector(`#${targetId}`).innerHTML = response.html;
                }
            }

            const navSubmenu = document.querySelector('.l-submenu');
            const yOffset = navSubmenu ? 220 : 160;
            const y = form.getBoundingClientRect().top + window.scrollY - yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }

        // remove error response if exists and reset the form
        $(form).find('.form__response--error').remove();
        $(form)[0].reset();

    }, function(response) {
        let errorMessage = '';

        if (response.status == 422) {
            for (var field in response.responseJSON) {
                if (response.responseJSON.hasOwnProperty(field)) {
                    errorMessage += response.responseJSON[ field ].join('<br>') + '<br>';
                }
            }
        } else if (response.status == 404) {
            errorMessage = 'Page not found - incorrect url.';
        } else if (response.responseJSON.message) {
            errorMessage = response.responseJSON.message;
        }

        if (errorMessage) {
            if ( $(form).find('.form__response--error').length === 0 ) {
                $(form).prepend( '<div class="form__response form__response--error"><p>'+errorMessage+'</p></div>' );
            } else {
                $('.form__response--error p').html(errorMessage);
            }
        }

        if (response.responseJSON && response.responseJSON.is_v3_recaptcha_error) {
            loadScript(`https://www.google.com/recaptcha/api.js`, function() {
                const recaptchaFallback = document.getElementById('recaptcha-fallback');

                if (recaptchaFallback) {
                    recaptchaFallback.style.display = 'block';
                }
            });
        }

        // remove success response if exists
        $(form).find('.form__response--ok').remove();

        $(form).find('button[type="submit"]').text(buttonTextOriginal);
        $(form).find('.loading').fadeOut();

        trackFormSubmission({status: 'Unsuccessful - user did not fill out all fields.', eventName, eventCategoryName});

        const navSubmenu = document.querySelector('.l-submenu');
        const yOffset = navSubmenu ? 220 : 160;
        const y = form.getBoundingClientRect().top + window.scrollY - yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    });

    return false;
};